
// scripts for the custom add to cart functionality for the add to cart page

jQuery(document).ready(function(){
  
  var $this = this;
  jQuery('.custom-submit').on('click', function($this){
    var target = $this;
    var parent = target.delegateTarget.nextSibling.parentElement;
    var nearestDiv = jQuery(parent).siblings('div.quantity');
    var childNodes = target.currentTarget.childNodes[1];
    var priceNode = target.currentTarget.childNodes[3];
    var valToChange = childNodes.attributes[1].value;
    var valToPut = childNodes.attributes[2].value;
    
    console.log(target.currentTarget.childNodes);
    function shopAdd(){
      
        var tempId = jQuery(nearestDiv).find('input[type="hidden"]').val();
        var tempQty = jQuery(nearestDiv).find('input[type="number"]').val();
      
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data:'quantity='+tempQty+'&id='+tempId,
        dataType: 'json',
        beforeSend: inputQtyCheck,
        success: function(){
          shopAddSuccess();
          // run the function to update the cart counter in the header and also in the sidebar 
        
          // also change the button text from add to cart to added and after 5s change back to add to cart
          jQuery(childNodes).text(valToChange);
          jQuery(priceNode).css('display', 'none');
          window.setTimeout(function(){
            jQuery(childNodes).text(valToPut);
          jQuery(priceNode).css('display', 'inline-block');
          }, 3000);
          
          // also disabled the button before completing the request
          
        },
        error: function(e){
         console.log('Ooops! Problem adding to the cart');
        }
      }
     jQuery.ajax(params);
    }  
    
    shopAdd();
 function shopAddSuccess(){
      
      jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        success: function(data){
           var cartData = jQuery.parseJSON(data);           
           jQuery('.cart-item-count-header').text(cartData.item_count);
           jQuery('.cart-item-count-header--quantity').text(cartData.item_count);
        }
      })
      
    }
    
    function inputQtyCheck(xhr){
        var tempQty = jQuery(nearestDiv).find('input[type="number"]').val();
      
      if( tempQty < 0){
        xhr.abort();
        console.log('Aborted successfully !');
      }
      if(tempQty % 1 != 0){
       console.log('decimal number');
       xhr.abort();
      }
    }
    
  });
});  

    jQuery(document).ready(function(){
      jQuery('.variant-button').on('click', function($this){
        var toFetch = $this.currentTarget;
        
        var variantVal = jQuery(toFetch).attr('data-variant-id');
        var variantPrice = jQuery(toFetch).attr('data-price');
        

         var divTofind = jQuery(toFetch).parent().parent().parent().parent().siblings().find('div.quantity');
         var varInput = jQuery(divTofind).children()[0];
        
         var priceContainer = jQuery(toFetch).parent().parent().parent().parent().siblings().find('div.add-to-cart');
        var priceVal = jQuery(priceContainer).children()[0];
        var spanTochange = jQuery(priceVal).find('span.submit-btn--price');
      
        jQuery(varInput).val(variantVal);
        
        jQuery(spanTochange).text(variantPrice);           
    });
    
    
    });  